import { STATUS_ICON_CHECK_O, STATUS_ICON_TIMES_O, STATUS_ICON_WARNING } from '@/common/utils/statuses';
import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export enum VIRTUAL_ROUTER_STATUSES {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  DOWN = 'DOWN',
}

type VirtualRouterStatusMap = Record<VIRTUAL_ROUTER_STATUSES, StatusData>;

export const VIRTUAL_ROUTER_STATUS_MAP = computedLocale<VirtualRouterStatusMap>(() => ({
  [VIRTUAL_ROUTER_STATUSES.ACTIVE]: {
    icon: STATUS_ICON_CHECK_O,
    text: i18n.t('Active'),
  },
  [VIRTUAL_ROUTER_STATUSES.ERROR]: {
    icon: STATUS_ICON_TIMES_O,
    text: i18n.t('Error'),
  },
  [VIRTUAL_ROUTER_STATUSES.DOWN]: {
    icon: STATUS_ICON_WARNING,
    text: i18n.t('Down'),
  },
}));
